















































































































































































import { Component, Mixins, Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";
import NotificationMixin from "@/mixins/notification.mixin";
import ConfigStyle from "@/components/ConfigStyle.vue";

const InvoiceTemplates = namespace("InvoiceTemplateModule");

@Component({
  name: "InvoiceTemplate",
  mixins: [NotificationMixin],
  components: {
    ConfigStyle,
  },
})

export default class Configuration extends Mixins(NotificationMixin) {
  protected loading = false;
  protected isChangeTemplate = false;
  protected addNew = false;
  protected templateSelected: any = {
    name: 'Hotel invoices',
    key: 'hotel-invoice',
  };
  protected fontList: Array<string> = [];
  protected invoiceTemplates: Array<object> = [
    {
      name: 'Hotel invoices',
      key: 'hotel-invoice',
    },
    {
      name: 'Airline invoices',
      key: 'airline-invoice',
    },
    {
      name: 'Hotel credit invoices',
      key: 'hotel-credit-invoice',
    },
    {
      name: 'Airline credit invoices',
      key: 'airline-credit-invoice',
    },
  ];
  protected logo: File | null = null;

  private config: object = {
    align: 'left',
    fontStyle: 'normal',
    fontType: 'Roboto',
    fontSize: '14',
  }

  async mounted() {
    this.fontList = await this.getFontList();
    await this.getItem('hotel-invoice');
  }

  onFileChange(e: any) {
    const file = e.target.files[0];
    this.logoConfig.url = URL.createObjectURL(file);
  }

  async save() {
    this.loading = true;
    if (this.logo) {
      const uploadLogo = await this.uploadLogo(this.logo);
      if(uploadLogo.success) {
        this.logoConfig.url = uploadLogo.data[0].Location;
      } else {
        this.loading = false;
        return false;
      }
    }
    const result = await this.saveItem({
      key: this.templateSelected.key,
      name: this.templateSelected.name,
      addNew: this.addNew,
    });
    if (result.success) {
      this.onShowFlashMessage("Update successfully!");
      this.addNew = false;
    } else {
      this.onShowFlashMessage(result.message, "Error", "danger");
    }
    this.loading = false;
  }

  async changeTemplate(template: any) {
    this.isChangeTemplate = true;
    this.templateSelected = template;
    const result = await this.getItem(template.key);
    if (!result.success) {
      this.addNew = true;
    }
    this.isChangeTemplate = false;
  }

  @Watch('logoConfig', { deep: true })
  logoConfigChanged() {
    this.renderCss();
  }

  @Watch('listConfig', { deep: true })
  listConfigChanged() {
    this.renderCss();
  }

  @InvoiceTemplates.State
  public logoConfig!: any;

  @InvoiceTemplates.State
  public listConfig!: Array<object>;

  @InvoiceTemplates.State
  public style!: Array<object>;

  @InvoiceTemplates.Mutation
  public renderCss!: () => Promise<any>;

  @InvoiceTemplates.Action
  public getFontList!: () => Promise<any>;

  @InvoiceTemplates.Action
  public getItem!: (type: string) => Promise<any>;

  @InvoiceTemplates.Action
  public saveItem!: (params: any) => Promise<any>;

  @InvoiceTemplates.Action
  public uploadLogo!: (file: File) => Promise<any>;
}
